import { useMutation } from '@tanstack/react-query';

import { logger } from '@/utils';

import { updateUser } from '../api';
import { usersQueryKeys } from '../data';

export const useUpdateUser = () => {
  const mutation = useMutation({
    mutationKey: usersQueryKeys.updateUser,

    mutationFn: updateUser,

    onMutate: (data) => {
      return { ...data };
    },

    onSuccess: (data) => {
      logger.log(data);
    },

    onError: (error) => {
      logger.log(error);
    },
  });

  return mutation;
};
